import EpiComponent, { EpiComponentType } from './EpiComponent';
import EpiserverContext from '../Spa';

const CmsComponent : EpiComponentType = EpiComponent.CreateComponent(EpiserverContext);
export default CmsComponent;